export default {
    fields: {
        name: {
            label: 'Naziv',
            placeholder: 'Unesite naziv kompanije',
        },
        pib: {
            label: 'PIB',
            placeholder: 'Unesite PIB kompanije',
        },
        address: {
            label: 'Adresa',
            placeholder: 'Unesite adresu',
        },
        subDomain: {
            label: 'Subdomen',
            placeholder: 'Unesite SubDomain',
        },
        city: {
            label: 'Grad',
            placeholder: 'Izaberite grad',
        },
        country: {
            label: 'Država',
            placeholder: 'Izaberite državu',
            SERBIA: 'Srbija',
            BOSNIA: 'Bosna i Hercegovina',
        },
        theme: {
            label: 'Tema',
            placeholder: 'Izaberite temu',
        },
    },
    price_increase: 'Aktivacijom subdomaina povećava se cena održavanja za {subdomainPrice}',
    subdomain_removal:
        'Zatraženo je brisanje subdomaina na datum {removalDate}. Subdomain će biti obrisan 1. u narednom mesecu po isteku pretplate (subskripcije)',
    start_for_free: 'Počnite besplatno',
    choose_package: 'Izaberite paket',
    update_company_heading: 'Da li ste sigurni da želite da sačuvate podešavanja kompanije?',
    deactivate_company_heading: 'Jeste li sigurni da želite da deaktivirate kompaniju?',
    no_companies: 'Trenutno nemate kreiranih kompanija. Da li želite da to uradite sada?',
}
